/**
 * RoarAboutPage — About page with team story, mission, and leadership grid.
 */
import React from 'react';
import PageHeader from './PageHeader';
import LeadershipGrid from './LeadershipGrid';
import { useReveal } from '../../hooks/useReveal';
import styles from './RoarAboutPage.module.css';

function RoarAboutPage() {
  const story = useReveal();
  const mission = useReveal();
  const leaders = useReveal();

  return (
    <div className={`roar-page ${styles.page}`}>
      <PageHeader
        eyebrow="About"
        title="Built by students, season after season"
        lead="Roarbotics started in 2019 as a small group at Fairfax High School. We've grown into a competitive FTC program — still student-led, still learning on real hardware."
      />

      <section
        ref={story.ref}
        className={`${styles.block} roar-reveal ${story.visible ? 'is-visible' : ''}`}
      >
        <div className={styles.storyGrid}>
          <div className={styles.prose}>
            <p>
              Every year we get six weeks of game reveal, then months of design,
              fabrication, programming, and testing. Students own the work:
              CAD, machining, wiring, autonomous, drive team, outreach, and
              sponsor relations.
            </p>
            <p>
              We compete in FIRST Tech Challenge across Virginia and beyond.
              Our results matter, but the point is learning how to ship something
              that works under pressure — the same skill set industry teams use.
            </p>
          </div>
          <aside className={styles.aside}>
            <strong>Since 2019</strong>
            FTC team at Fairfax High School. State qualifier. Connect Award
            recipient. Still adding tools to the shop every season.
          </aside>
        </div>
      </section>

      <section
        ref={mission.ref}
        className={`${styles.block} roar-reveal ${mission.visible ? 'is-visible' : ''}`}
      >
        <h2 className={styles.sectionTitle}>Mission</h2>
        <p className={styles.mission}>
          Give Fairfax students a place to practice serious engineering — design
          reviews, deadlines, failure analysis, and competition — while staying
          accessible to anyone willing to put in the work.
        </p>
      </section>

      <section
        ref={leaders.ref}
        className={`${styles.block} roar-reveal ${leaders.visible ? 'is-visible' : ''}`}
      >
        <h2 className={styles.sectionTitle}>Leadership</h2>
        <LeadershipGrid />
      </section>
    </div>
  );
}

export default RoarAboutPage;
